import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, map, Observable, of, throwError } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { AlertApi } from './models';
import { NotfDateRangeApi } from './models/notf-date-range-api';
import { AppConstants } from '../../app.constants';
import { Alert } from '../domain/models';
import { NotfAlertConstants } from '../notf.constants';

@Injectable({
    providedIn: 'root'
})
export class AlertMiscApiService extends BaseMiscApiService
{
    constructor (protected http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlAuth;
        this.segmentApi = '/auth/alerts';
    }

    getAlerts (): Observable<AlertApi[]>
    {
        return this.get<AlertApi[]>('');
    }

    getActiveAlerts (): Observable<AlertApi[]>
    {
        return this.get<AlertApi[]>('/active');
    }

    createAlert (alert: Alert): Observable<AlertApi>
    {
        return this.post<AlertApi>('', AlertMiscApiService.apiPayload(alert));
    }

    updateAlert(alert: Alert): Observable<AlertApi>
    {
        return this.patch<AlertApi>('', AlertMiscApiService.apiPayload(alert));
    }

    /**
     * Construit le corps envoye a l'API. Indispensable car les alertes circulent dans des actions NgRx :
     * celles-ci ajoutent une propriete « type » (leur discriminant) qui, parti vers l'API, serait rejetee
     * par l'enum AlertType du backend, et la nature de l'alerte doit reprendre son nom de contrat, « type ».
     */
    private static apiPayload (alert: Alert): AlertApi
    {
        const payload: AlertApi = new AlertApi();

        payload.active = alert.active;
        payload.createdAt = null;
        payload.id = alert.id;
        payload.title = alert.title;
        payload.text = alert.text;
        payload.rangeActivation = alert.rangeActivation as unknown as NotfDateRangeApi;
        payload.type = alert.alertType ?? null;
        payload.backgroundColor = NotfAlertConstants.isAllowedColor(alert.backgroundColor) ? alert.backgroundColor : null;

        return payload;
    }

    disableAlert (alertId: string): Observable<void>
    {
        return this.patch(`/disable/${alertId}`, {});
    }

    activateAlert (alertId: string): Observable<void>
    {
        return this.patch(`/activate/${alertId}`, {});
    }

    deleteAlert (alertId: string): Observable<void>
    {
        return this.delete(`/delete/${alertId}`, {});
    }
}
